import "./Collections.module.css";
import StudioThorneHeader from "@/reusable_sections/Header";
import ArchiveCurrent from "./sections/ArchiveCurrent";
import TheLookbookGallery from "./sections/TheLookbookGallery";
import StudioThorneFooter from "@/reusable_sections/Footer";
export default function CollectionsPage() {
  return <div>
      <StudioThorneHeader />
      <ArchiveCurrent />
      <TheLookbookGallery />
      <StudioThorneFooter />
    </div>;
}